import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#5D4E37] text-[#EDE8DC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* About */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <h3 className="text-2xl font-serif font-semibold text-white tracking-tight leading-tight mb-1">
                Anthony Savarit
              </h3>
              <p className="text-xs font-light text-[#D4A574] tracking-widest uppercase">
                Professeur de guitare
              </p>
            </div>
            <p className="text-sm leading-relaxed font-light max-w-md opacity-90">Cours privés à domicile à Genève, pensés pour enfants, adultes et débutants exigeants.


            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4 tracking-wide uppercase">Navigation</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/" className="inline-flex items-center min-h-[40px] py-2 text-sm font-light hover:text-[#D4A574] transition-colors opacity-90 hover:opacity-100">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/booking" className="inline-flex items-center min-h-[40px] py-2 text-sm font-light hover:text-[#D4A574] transition-colors opacity-90 hover:opacity-100">
                  Réserver
                </Link>
              </li>
              <li>
                <a href="#tarifs" className="inline-flex items-center min-h-[40px] py-2 text-sm font-light hover:text-[#D4A574] transition-colors opacity-90 hover:opacity-100">
                  Tarifs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4 tracking-wide uppercase">Contact</h4>
            <ul className="space-y-1">
              <li className="flex items-center space-x-3 min-h-[40px]">
                <Mail className="w-4 h-4 text-[#D4A574] flex-shrink-0" />
                <a
                  href="mailto:booking@savaritlessons.ch"
                  className="inline-flex items-center min-h-[40px] py-2 text-sm font-light hover:text-[#D4A574] transition-colors opacity-90 hover:opacity-100 break-all"
                >
                  booking@savaritlessons.ch
                </a>
              </li>
              <li className="flex items-center space-x-3 min-h-[40px]">
                <Phone className="w-4 h-4 text-[#D4A574] flex-shrink-0" />
                <a href="tel:+41799097817" className="inline-flex items-center min-h-[40px] py-2 text-sm font-light hover:text-[#D4A574] transition-colors opacity-90 hover:opacity-100 whitespace-nowrap">
                  +41 79 909 78 17
                </a>
              </li>
              <li className="flex items-start space-x-3 min-h-[40px]">
                <MapPin className="w-4 h-4 text-[#D4A574] mt-3 flex-shrink-0" />
                <span className="text-sm font-light opacity-90 py-2">Genève et environs</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#6B5D4F] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-xs font-light opacity-75">
            © {new Date().getFullYear()} Anthony Savarit. Tous droits réservés.
          </p>
          <div className="flex space-x-8">
            <Link to="/conditions" className="inline-flex items-center min-h-[40px] py-2 text-xs font-light opacity-75 hover:opacity-100 transition-opacity" data-testid="footer-terms-link">
              Conditions d&apos;utilisation
            </Link>
          </div>
        </div>
      </div>
    </footer>);

};

export default React.memo(Footer);